import * as React from 'react';

function SvgIconVideoPlaceholder(props) {
  return (
    <svg width={208} height={88} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path fill="#E8E8E8" d="M16 18h176v2H16z" />
      <rect x={104} y={28} width={88} height={22} rx={2} fill="#E8E8E8" />
      <path
        fill="#E8E8E8"
        d="M16 28h80v2H16zm0 10h80v2H16zm0 10h80v2H16zm0 10h176v2H16zm0 10h176v2H16z"
      />
      <path d="M154 39l-9 5.196V33.804L154 39z" fill="#FAFAFA" />
    </svg>
  );
}

export default SvgIconVideoPlaceholder;
